import $ from 'jquery';
import { renderPersonalApp } from './react/PersonalApp';
import { allowedLocales } from "scripts/utils/constants"

const AJAX = '';
let locale = document.documentElement.lang || 'en';
if (!(locale in allowedLocales)) {
  locale = allowedLocales.uk;
}

const initCalendar = () => {
  function formatDate() {
    const date = new Date(); 

    date.setDate(date.getDate());
    date.setMonth(date.getMonth());
    date.setFullYear(date.getFullYear() - 18);
    return date;    
  }

  const calendar = $('#dateCalendar');
  if(calendar.length){
    const updateSelect = ()=>{
      setTimeout(()=>{
          window.customSelect.update('.ui-datepicker-month');
          window.customSelect.update('.ui-datepicker-year');
        },0);
    };
    if (!$.datepicker._generateMonthYearHeader_original) {
      $.datepicker._generateMonthYearHeader_original = $.datepicker._generateMonthYearHeader;
      $.datepicker._generateMonthYearHeader = function(inst, dm, dy, mnd, mxd, s, mn, mns) {
        var header = $($.datepicker._generateMonthYearHeader_original(inst, dm, dy, mnd, mxd, s, mn, mns)),
          years = header.find('.ui-datepicker-year');
        years.html(Array.prototype.reverse.apply(years.children()));
        return $('<div />').append(header).html();
      }
    }
    $.datepicker.setDefaults( $.datepicker.regional[locale] );
    const fullmonth = ($.datepicker.regional[locale] || $.datepicker.regional['en']).monthNames;
    const date = $('#fullDate').val();
    const params = {
      changeMonth: true,
      changeYear: true,
      yearRange: `-100:-18`,
      dateFormat: 'dd MM yy',
      monthNamesShort: fullmonth,
      maxDate: new Date(formatDate()),

      onSelect: () => {
        updateSelect();
      },
      onChangeMonthYear: () =>{
        updateSelect();
      },
    };

    if(date !== '' && date !== undefined){
      params.defaultDate = new Date(date);
    }

    calendar.datepicker(params);
    $(".ui-datepicker").addClass("notranslate")
    $("#dateCalendar").addClass("notranslate")
    updateSelect();
  }else{
    const date = $('#fullDate');
    if(date.val() !== ''){
      const value = date.val();
      const parseDate = new Date(value);
      const DatePickerFormat = $.datepicker.formatDate("dd MM yy", parseDate)

     $('#textDate').val(DatePickerFormat);
    }
  }
};

const calendarNav = ()=>{
  const saveButton = $('.save-calendar');
  const closeCalendar = $('.close-calendar');

  saveButton.on('click',(e)=>{
    e.preventDefault();
    const hiddenDate = $.datepicker.formatDate('yy-mm-dd', $('#dateCalendar').datepicker('getDate'));
    const textDate = hiddenDate.split('-');
    textDate[1] = $.datepicker.formatDate('MM', $('#dateCalendar').datepicker('getDate'));
    const reverseValue = textDate.reverse().join(' ');

    [
      ['fullDate', hiddenDate],
      ['textDate', reverseValue]
    ].forEach(([id, value]) => {
      const input = document.getElementById(id);
      if (input) {
        input.value = value;
        input.dispatchEvent(new Event('change'));
      }
    });
  });

  closeCalendar.on('click', (e)=>{
    e.preventDefault();
    $('.date-calendar').fadeOut(300);
  });
}

const addShowCalendarListener = () =>{
  const opener = $('#textDate');
  const calendarHolder = $('.date-calendar');

  opener.on('keypress', e =>{
    e.preventDefault();
  })

  opener.on('click', () =>{
    calendarHolder.fadeIn(300);
  });

  calendarHolder.on('click', (e) => {
    e.stopPropagation();
    e.preventDefault();
  });
  $(document).mouseup(e => {
    if (!calendarHolder.is(e.target) && calendarHolder.has(e.target).length === 0) {
      calendarHolder.fadeOut(300);
    }
  });
  
}
export const initProfileCalendar = () => {
  initCalendar();
  calendarNav();
  addShowCalendarListener();
}

/**
 * Lazy-loads datepicker, locale, and profile calendar scripts on birthday input focus
 */
export const initDatepickerCalendar = async (initializationCallback) => {
  /* Load datepicker base and i18n (if needed) simultaneously */
  const imports = [import("jquery-datepicker")]
  if (locale === "uk") {
    imports.push(import(/* webpackChunkName: "datepicker-uk" */ "jquery-datepicker/i18n/jquery.ui.datepicker-uk"))
  } else if (locale === "ru") {
    imports.push(import(/* webpackChunkName: "datepicker-ru" */ "jquery-datepicker/i18n/jquery.ui.datepicker-ru"))
  }

  const results = await Promise.allSettled(imports)

  // Apply base datepicker (required)
  if (results[0].status === "fulfilled") {
    results[0].value.default($)
  } else {
    console.error("Failed to load datepicker:", results[0].reason)
    return
  }

  // Apply i18n if loaded successfully; fallback to English if it fails
  if (results[1]?.status === "fulfilled") {
    results[1].value.default($)
  }

  // Defer to next tick so i18n registers to $.datepicker.regional
  await new Promise((r) => {setTimeout(r, 0)})

  initializationCallback()
}

const bonusCardTooltip = () =>{
  const opener = $('.account-discount__numbers .image img');

  opener.on('click', function openTooltip(){
    const siblingsTooltip = $(this).siblings('.image__tooltip');

    $('.image__tooltip').not(siblingsTooltip).fadeOut(300)
    siblingsTooltip.fadeToggle(300);
  });
  $(document).mouseup(e => {
    if (!opener.is(e.target) && opener.has(e.target).length === 0) {
      $('.image__tooltip').fadeOut(300);
    }
  });
}

const updateWishlistCounter = count => {
  const counter = $(".js_compare_count");
  counter.text(count)[count > 0 ? "removeClass" : "addClass"]("hide");
};

const wishlist = () =>{
  const destroyAll = ()=>{
    const btn = $('.profile-list__head .remove');

    btn.on('click', (e)=>{
      e.preventDefault();

      $.ajax({
        url: `${AJAX}/api/favorites/destroy_all/`,
        type: 'GET',
        headers: {
          'Accept-Language': locale
        },
        dataType: 'json',
        success: ({data}) => {
          updateWishlistCounter(data.favorites.length);
          const empty = `<div class="not-found">${data.phrases.common.empty}</div>`
          $('.profile-list__favorite .product-card').remove();
          $('.profile-list__favorite').html(empty);
          btn.hide();
        }
      });
    });
  }

  const removeFromWishlist = ()=>{
    const btn = $('.js_favorite');

    btn.on('click', function removeItem (e){
      const $this = $(this);
      const id = $this.parents('.product-card__content').attr('data-id');
      e.preventDefault();

      $.ajax({
        url: `${AJAX}/api/favorites/${id}/`,
        type: 'DELETE',
        headers: {
          'Accept-Language': locale
        },
        dataType: 'json',
        success: ({data}) => {
          updateWishlistCounter(data.favorites.length);
          $this.parents('.product-card').remove();
          if(!data.favorites.length){
            const empty = `<div class="not-found">${data.phrases.common.empty}</div>`;

            $('.profile-list__head .remove').hide();
            $('.profile-list__favorite').append(empty);
          }
        }
      });
    });
  }

  removeFromWishlist();
  destroyAll();
}

const profile = () =>{
  const discountLine = () =>{
    const discountCard = $('.account-discount');
    
    if(discountCard.length){
      const getNum = string => +string.replace(/[^a-z0-9]/gi, '');

      discountCard.each((key, item)=>{
        const frstVal = $(item).find('.value-frst').text();
        const scndVal = $(item).find('.value-scnd').text();
        const countPercent = (getNum(frstVal) * 100) / getNum(scndVal);

        $(item).find('.status-bar__line .line').css({
          'width':`${countPercent}%`
        })
      });
      
    }
  }

  wishlist();
  bonusCardTooltip();
  discountLine();
  renderPersonalApp();
}

export default profile;